import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./components/Header";
import Footer from './components/Footer';
import Project from "./components/Project";
import Team from "./components/Team";
import Journal from './components/Journal';
import Deliverables from './components/Deliverables'
import React, { Component } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap'

class App extends Component {

  static defaultProps = {
    pages : [
      Project, Team, Journal, Deliverables
    ]
  }

  constructor(props){
    super(props)
    this.state = { matches: window.matchMedia("(min-width: 768px)").matches };
  }

  componentDidMount() {
    const handler = e => this.setState({matches: e.matches});
    window.matchMedia("(min-width: 768px)").addListener(handler);
  }

  render() {
      return (
        <Container>
          <Header group={'Saurav Bahali, Charles Chow, Habib Khadri, and Rahul Narvekar'}></Header>
          <Tabs defaultActiveKey="project" transition={false} id="noanim-tab-example"className="mb-3" style={{backgroundColor:"lightgray"}}>
            <Tab eventKey="project" title="Project">
              <Project></Project>
            </Tab>
            <Tab eventKey="team" title="Team">
              <Team></Team>
            </Tab>
            <Tab eventKey="journal" title="Journal">
              <Journal></Journal>
            </Tab>
            <Tab eventKey="deliverables" title="Deliverables">
              <Deliverables mobile={this.state.matches}></Deliverables>
            </Tab>
          </Tabs>
          <Footer></Footer>
        </Container>
      );
    }
}

export default App;